import { Component, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BusinessClock } from './business-clock.service';

export const businessClockGuard: CanActivateFn = async (_route, state) => {
  const clock = inject(BusinessClock);
  if (await clock.synchronize()) { clock.retryPath = ''; return true; }
  clock.retryPath = state.url;
  return false;
};

@Component({
  selector: 'app-business-clock-status',
  template: `@if (clock.message()) {
    <section role="alert" class="business-clock-status" aria-live="polite">
      <p>{{ clock.message() }}</p>
      <button type="button" (click)="retry()" [disabled]="clock.loading()">{{ clock.loading() ? '日時を確認中…' : '日時を再取得' }}</button>
    </section>
  }`,
  styles: [`.business-clock-status { position:sticky;top:0;z-index:3000;background:#fff3cd;color:#513b00;border:2px solid #997100;padding:12px 20px; } p { margin:0 0 8px; } button { padding:6px 14px; }`],
})
export class BusinessClockStatus {
  readonly clock = inject(BusinessClock);
  private readonly router = inject(Router);
  constructor() { this.clock.install(); }
  async retry(): Promise<void> {
    if (await this.clock.synchronize(true) && this.clock.retryPath) {
      const path = this.clock.retryPath;
      this.clock.retryPath = '';
      await this.router.navigateByUrl(path);
    }
  }
}
